import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'usuarios',
})
export class UsuariosPipe implements PipeTransform {

  transform(items: any[], filter: any[]) {


    if(filter['id_role'] > 0){

      items = items.filter(function(item) {
        return item.id_role == filter['id_role'];
      });
    }


    return items;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/usuarios/usuarios.ts